import { v1 } from "uuid"
import { simpleDeepClone } from ".."
import { generateSubHeadPage, getWebsiteSubHeadPages } from "@/api/page"
import { createComponentApp } from "@/api/module"
import axios from "axios"
const uuid = { v1 }

export async function createNewAppId(oldAppId, pageId) {
  const result = await createComponentApp({
    params: {
      a: oldAppId,
      w: -10,
      p: pageId,
      c: {},
      t2: "31CB73E03E24BBFF",
      t: "临时",
      clone: true
    }
  })
  return result.data.data.appId
}

/**
 * 从当前网站头解析出一个独立头用于生成二级头页面
 * @param {*} page 
 * @returns 
 */
export function parseHeader(page, pageId) {
  const { pageLayoutList, children, subPages } = page
  let headerPageLayout = pageLayoutList.find(item => item?.options?.inDocument === 'header')
  if (!headerPageLayout) return null
  headerPageLayout = simpleDeepClone(headerPageLayout)
  headerPageLayout.options.isShow = true
  const headerRectIds = [], headerChildren = [], headerSubPages = [], headerRectIdsMap = {}, appIdList = [], drawerLayouts = [], otherLayouts = []
  handleFindAllRects(headerPageLayout, headerRectIds)
  if (headerRectIds.length) {
    headerRectIds.map((currentRectIdObject) => {
      console.log('当前值', currentRectIdObject)
      const { originRectId, newRectId } = currentRectIdObject
      headerRectIdsMap[originRectId] = newRectId
    }, {});
    for (let i = 0; i < (children[0]?.children || []).length; i++) {
      const rect = children[0].children[i]
      if (headerRectIdsMap[rect.rect_id]) {
        const copyRect = simpleDeepClone(rect)
        copyRect.rect_id = headerRectIdsMap[rect.rect_id]
        copyRect.options.inSubHead = true
        if (copyRect?.options?.appId) {
          // 如果该组件有appId，需要进行appId替换来避免改二级头的数据影响到一级头
          const subPageSetting = subPages.find(subPage => subPage.appId === copyRect.options.appId)
          subPageSetting && (headerSubPages.push(simpleDeepClone({...subPageSetting})))
          appIdList.push(copyRect?.options?.appId)
        }
        headerChildren.push(copyRect)
      }
    }
  }
  // 处理抽屉
  const drawerPageLayouts = pageLayoutList.filter(item => item?.options?.inDocument === 'drawer')
  if (drawerPageLayouts?.length) {
    drawerPageLayouts.forEach(drawerPageLayout => {
      const sourceButtonRectId = drawerPageLayout?.options?.source_id
      const inHead = headerRectIds.map(item => item.originRectId)?.includes(sourceButtonRectId)
      if (inHead) {
        drawerPageLayout = simpleDeepClone(drawerPageLayout)
        // 说明该抽屉也要同步到二级头里面去
        const drawerRectIds = [], drawerRectIdsMap = {}
        handleFindAllRects(drawerPageLayout, drawerRectIds)
        if (drawerRectIds.length) {
          drawerRectIds.map((currentRectIdObject) => {
            console.log('当前值', currentRectIdObject)
            const { originRectId, newRectId } = currentRectIdObject
            drawerRectIdsMap[originRectId] = newRectId
          }, {});
          for (let i = 0; i < (children[0]?.children || []).length; i++) {
            const rect = children[0].children[i]
            if (drawerRectIdsMap[rect.rect_id]) {
              const copyRect = simpleDeepClone(rect)
              copyRect.rect_id = drawerRectIdsMap[rect.rect_id]
              copyRect.options.inSubHead = true
              if (copyRect?.options?.appId) {
                // 如果该组件有appId，需要进行appId替换来避免改二级头的数据影响到一级头
                const subPageSetting = subPages.find(subPage => subPage.appId === copyRect.options.appId)
                subPageSetting && (headerSubPages.push(simpleDeepClone({...subPageSetting})))
                appIdList.push(copyRect?.options?.appId)
              }
              headerChildren.push(copyRect)
            }
          }
        }
        drawerPageLayout.options.source_id = headerRectIdsMap[sourceButtonRectId]
        drawerLayouts.push(drawerPageLayout)
      }
    })
  }
  // 处理变换头
  const relativeHeaderPageLayout = pageLayoutList.find(item => item?.options?.inDocument === 'relativeHeader')
  if (relativeHeaderPageLayout) {
    const relativeHeaderHandleResult = parsePageLayout(relativeHeaderPageLayout, children, subPages)
    const { _appIdList, _pageLayout, _subPages, _children } = relativeHeaderHandleResult
    _pageLayout.options.isShow = false
    _appIdList.map(id => {
      if (!appIdList.includes(id)) {
        appIdList.push(id)
      }
    })
    _subPages.map(subItem => {
      if (!headerSubPages.find(item => item.appId === subItem.appId)) {
        headerSubPages.push(simpleDeepClone({...subItem}))
      }
    })
    headerChildren.push(..._children)
    otherLayouts.push(_pageLayout)
  }
  return {
    isInitedFromInterface: true,
    page: {
      isSubHeadPage: true,
      appIdList,
      editPageThemeColor: page.editPageThemeColor,
      enableSubHead: false,
      enableLayoutFullScroll: page.enableLayoutFullScroll,
      enableTeleport: page.enableTeleport,
      global: page.global,
      globalBgSetting: page.globalBgSetting,
      globalStyle: page.globalStyle,
      height: 1440,
      id: 121131,
      isBackgroundFixed: page.isBackgroundFixed,
      isFullPage: page.isFullPage,
      isShowHeader: true,
      isShowFooter: false,
      isWaterFall: page.isWaterFall,
      managerType: page.managerType,
      name: '二级头',
      pageLayoutList: [headerPageLayout, ...otherLayouts,  ...drawerLayouts],
      pageLayoutType: page.pageLayoutType,
      pageWidth: page.pageWidth,
      showAllScreen: page.showAllScreen,
      themeColor: page.themeColor,
      children: [{
        ...page.children[0],
        children: headerChildren
      }, page.children[1]],
      subPages: headerSubPages,
      themeColor: page.themeColor
    },
    template_v2_mh: 1,
    treeData: undefined,
    type: "normal",
    version: 1
  }
}

export function parsePageLayout(pageLayout, parentChildren, parentSubPages) {
  if (!pageLayout) return null
  pageLayout = simpleDeepClone(pageLayout)
  const appIdList = [], rectIds = [], rectIdsMap = [], children = [], subPages = [];
  handleFindAllRects(pageLayout, rectIds)
  if (rectIds.length) {
    rectIds.map((currentRectIdObject) => {
      console.log('当前值', currentRectIdObject)
      const { originRectId, newRectId } = currentRectIdObject
      rectIdsMap[originRectId] = newRectId
    }, {});
    for (let i = 0; i < (parentChildren[0]?.children || []).length; i++) {
      const rect = parentChildren[0].children[i]
      if (rectIdsMap[rect.rect_id]) {
        const copyRect = simpleDeepClone(rect)
        copyRect.rect_id = rectIdsMap[rect.rect_id]
        copyRect.options.inSubHead = true
        if (copyRect?.options?.appId) {
          // 如果该组件有appId，需要进行appId替换来避免改二级头的数据影响到一级头
          const subPageSetting = parentSubPages.find(subPage => subPage.appId === copyRect.options.appId)
          subPageSetting && (subPages.push(simpleDeepClone({...subPageSetting})))
          appIdList.push(copyRect?.options?.appId)
        }
        children.push(copyRect)
      }
    }
  }
  return {
    _appIdList: appIdList,
    rectIds,
    rectIdsMap,
    _children: children,
    _subPages: subPages,
    _pageLayout: pageLayout
  }
}

/**
 * 保存头部，获取新生成的头部pageId
 */
export async function saveSubHeader(data, p) {
  const result = await axios({
    method: "post",
    url: "/v2/sub-header/add" + (p ? `?p=${p}` : ''),
    headers: { "Content-Type": "application/json;charset=utf-8" },
    data: data
  })
  return result?.data?.data?.publicId
}

export function findAllRects(layout) {
  const rectIds = []
  handleFindAllRects(layout, rectIds)
  return rectIds
}

/**
 *
 * @param {*} layout
 * @param {*} _rectIds
 */
function handleFindAllRects(layout, _rectIds) {
  let curLayout = layout
  let result = null
  if (curLayout) {
    if (curLayout.layout.rows && curLayout.layout.rows.length > 0 && result === null) {
      curLayout.layout.rows.forEach(item => {
        if (item.rectIds.length > 0) {
          for (let i in item.rectIds) {
            const newRectId = uuid.v1()
            _rectIds.push({originRectId: item.rectIds[i], newRectId})
            item.rectIds[i] = newRectId
          }
        }
        handleFindAllRects(item, _rectIds)
      })
    } else if (curLayout.layout.cols && curLayout.layout.cols.length > 0 && result === null) {
      curLayout.layout.cols.forEach(item => {
        if (item.rectIds.length > 0) {
          for (let i in item.rectIds) {
            const newRectId = uuid.v1()
            _rectIds.push({originRectId: item.rectIds[i], newRectId})
            item.rectIds[i] = newRectId
          }
        }
        handleFindAllRects(item, _rectIds)
      })
    } else return
  }
  return result
}

export async function getWebsiteSubHeadPageId(stageType) {
  let websiteSubHeadPageId = null
  const subHeadConfig = await getWebsiteSubHeadPages( "enableSubHead,subHeadPages", stageType ?? 0)
  let { enableSubHead, subHeadPages } = subHeadConfig?.data?.data ?? {}
  if (enableSubHead === 'true') {
    subHeadPages = JSON.parse(subHeadPages)
  } else return null
  subHeadPages?.length && (websiteSubHeadPageId = subHeadPages[0]?.headPageId)
  return websiteSubHeadPageId
}